import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage, useIntl } from '@divvy-web/i18n'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import GoToDashboardButton from '@sputnik/components/GoToDashboardButton'
import MarketingContent, { MarketingQuote } from '@sputnik/components/MarketingContent'
import AfterSubmitInfoPageLayout from '@sputnik/pages/PostApplicationPages/AfterSubmitInfoPageLayout'

import ExperianModal from './ExperianModal'
import { useGetAuthorizedSignerName } from './GetAuthorizedSignerName.gql'

const FrozenCredit = () => {
  const [getClassName] = useNameFormatter('FrozenCredit')
  const { formatMessage } = useIntl()
  const [isShowing, setIsShowing] = useState(false)
  const { appId } = useParams()

  const { data } = useGetAuthorizedSignerName({
    variables: { creditApplicationId: appId || '' },
  })

  const { firstName, lastName } = data?.creditApplication?.authorizedSigner || {}

  const signerName = firstName && lastName ? `${firstName} ${lastName}` : 'The authorized signer'
  return (
    <div>
      <AfterSubmitInfoPageLayout
        buttons={<GoToDashboardButton componentName={getClassName('')} />}
        imageName='frozen-credit-page'
        infoContent={
          <>
            <FormattedMessage
              defaultMessage="{signerName}'s credit is frozen. Please remove the security freeze with Experian and try again."
              id='sputnik.FrozenCredit__0wLquI'
              values={{ signerName }}
            />
            <FormattedMessage
              defaultMessage='We never do hard inquiries on credit. However, we do a soft pull on the authorized signer’s credit to verify identity and gather information for the application process. Please lift your security freeze with Experian and then visit the application dashboard to resubmit your saved application.'
              id='sputnik.FrozenCredit__sM/+oh'
            />
          </>
        }
        link={
          <TextLink
            size={TextLinkSizes.SMALL}
            onClick={() => setIsShowing(true)}
          >
            <FormattedMessage
              defaultMessage='How do I lift my credit freeze?'
              id='sputnik.FrozenCredit__tp7iH9'
            />
          </TextLink>
        }
        marketing={
          <MarketingContent
            image={{
              alt: formatMessage({
                defaultMessage: 'man smiling and shaking someone’s hand',
                id: 'sputnik.FrozenCredit__4VFaNh',
              }),
              src: 'https://app.divvy.co/assets/stock-photos/credit-application-frozen-credit.png',
              isRounded: true,
            }}
            pillText={
              <FormattedMessage
                defaultMessage='Testimonial'
                id='sputnik.FrozenCredit__MvBefC'
              />
            }
          >
            <MarketingQuote
              designation={
                <FormattedMessage
                  defaultMessage='CEO, HelpGood'
                  id='sputnik.FrozenCredit__R7D/wB'
                />
              }
              name={
                <FormattedMessage
                  defaultMessage='Michael Bellavia'
                  id='sputnik.FrozenCredit__SZFzOu'
                />
              }
              quote={
                <FormattedMessage
                  defaultMessage='“Spend & Expense has made communication with our bookkeeper, CPA, vendors, employees, and clients easier since <strong>we now have a single source of truth</strong>.”'
                  id='sputnik.FrozenCredit__8CfLdK'
                  values={{
                    strong: (chunks) => <b>{chunks}</b>,
                  }}
                />
              }
            />
          </MarketingContent>
        }
        title={
          <FormattedMessage
            defaultMessage='Your credit is frozen'
            id='sputnik.FrozenCredit__334LMo'
          />
        }
      />
      <ExperianModal
        isShowing={isShowing}
        onCloseClick={() => setIsShowing(false)}
      />
    </div>
  )
}

export default FrozenCredit
